var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Lib from "@core/libs";
var TableBuilder = /** @class */ (function (_super) {
    __extends(TableBuilder, _super);
    function TableBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableBuilder.prototype.onMounted = function () {
        var _this = this;
        var tableId = this.el.getAttribute('data-table');
        this.tableBuilderTable = this.el;
        this.filterContainerElement = document.querySelector("*[data-table-filter-for=\"".concat(tableId, "\"]"));
        if (this.filterContainerElement) {
            this.sortField = this.filterContainerElement.querySelector('*[data-is-sort-field]');
            this.tableHeader = document.querySelector("*[data-table-header-for=\"".concat(tableId, "\"]"));
            this.sortButtons = Array.from(this.tableHeader.querySelectorAll('*[data-is-sort-button]'));
            this.resetSortButton = this.tableHeader.querySelector('[data-is-sort-reset]');
            if (this.resetSortButton) {
                this.resetSortButton.addEventListener('click', function () {
                    _this.sortField.value = '';
                    if (_this.sortField.form) {
                        _this.sortField.form.submit();
                    }
                });
            }
            this.sortButtons.forEach(function (sortButton) {
                var fieldName = sortButton.getAttribute('data-sort-field-name');
                var clearButtonSelector = "*[data-is-sort-clear-button][data-sort-field-name=\"".concat(fieldName, "\"]");
                var clearButton = _this.tableHeader.querySelector(clearButtonSelector);
                _this.registerSortButtonEvents(sortButton, clearButton);
            });
        }
        this.paginatorElement = this.el.querySelector('.tc-pagination');
        if (this.paginatorElement) {
            this.pageInput = this.paginatorElement.querySelector('input[name="page"]');
            this.pageButtons = Array.from(this.paginatorElement.querySelectorAll('button[data-is-page-button]'));
            this.pageButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    _this.updatePage(button.value);
                });
            });
            this.pageSelect = this.paginatorElement.querySelector('select[data-is-page-select]');
            this.pageSelect.addEventListener('change', function (e) {
                if (_this.pageSelect.selectedIndex > -1) {
                    var value = _this.pageSelect.value;
                    if (value) {
                        _this.updatePage(value);
                    }
                }
            });
        }
    };
    TableBuilder.prototype.updatePage = function (pageNumber) {
        this.pageInput.value = pageNumber;
        if (this.pageInput.form) {
            this.pageInput.form.submit();
        }
    };
    TableBuilder.prototype.updateSorts = function (sortButton, addSender, removeSender) {
        var sortStr = this.sortField.value;
        var sorts = sortStr ? sortStr.split(',') : [];
        var currentSort = sortButton.getAttribute('data-sort-value');
        var nextSort = sortButton.getAttribute('data-sort-next');
        var currentIndex = currentSort ? sorts.indexOf(currentSort) : -1;
        var nextIndex = nextSort ? sorts.indexOf(nextSort) : -1;
        if (addSender) {
            if (currentIndex >= 0) {
                sorts[currentIndex] = nextSort;
            }
            else if (nextIndex === -1) {
                sorts.push(nextSort);
            }
        }
        if (removeSender) {
            if (currentIndex > -1) {
                sorts.splice(currentIndex, 1);
            }
        }
        this.sortField.value = sorts.join(',');
        console.log('final sorts', sorts);
        if (this.sortField.form) {
            this.sortField.form.submit();
        }
    };
    TableBuilder.prototype.registerSortButtonEvents = function (sortButton, clearButton) {
        var _this = this;
        sortButton.addEventListener('click', function (e) {
            _this.updateSorts(sortButton, true, false);
        });
        if (clearButton) {
            clearButton.addEventListener('click', function (e) {
                sortButton.removeAttribute('data-is-active');
                _this.updateSorts(sortButton, false, true);
            });
        }
    };
    ;
    return TableBuilder;
}(Lib));
export default TableBuilder;
